module.exports = __webpack_public_path__ + "static/media/logo.edcbd7f4.png";